// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:ds:Kwz4qm */\n.jU6pr{animation:C6SiG 1s linear infinite;border:2px solid;border-radius:var(--audio-radius-pill);border-top:2px solid transparent;color:var(--audio-content-primary);display:inline-block;height:1.5rem;width:1.5rem}@keyframes C6SiG{to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": "jU6pr",
	"spin": "C6SiG"
};
export default ___CSS_LOADER_EXPORT___;
